


























import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import TrainResultDataBefore from '@/trials/views/trials/train/result/TrainResultDataBefore.vue';
import TrainResultDataAfter from '@/trials/views/trials/train/result/TrainResultDataAfter.vue';

@Component({ components: { TrainResultDataBefore, TrainResultDataAfter } })
export default class TrainResultData extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // 表示コンテンツ
        sessionModule.SET_ROUTE_TRAIN_RESULT(SC.Path.TRAIN_RESULT_DATA);
    }
    /*----------------------------------*
     * Methods
     *-----------------------------------*/
}
